import {
  ClientInvoiceFuelSurchargeFields,
  EditClientInvoiceUIRequest,
} from "../ClientInvoiceInterfaces";

export const mapValuesUiRequestToUpdateFuelSurchargeFields = (
  uiRequest: EditClientInvoiceUIRequest,
  username: string | undefined,
  invoiceStatus: string
): ClientInvoiceFuelSurchargeFields[] => {
  let fuelSurchargeFieldsList: ClientInvoiceFuelSurchargeFields[] = [];

  if (uiRequest.show_fuel_surcharge) {
    if (uiRequest.fuelSurchargeFields.length > 0) {
      uiRequest.fuelSurchargeFields.forEach((surcharge) => {
        if (surcharge.fieldName && surcharge.fieldOperator) {
          let field: ClientInvoiceFuelSurchargeFields = {
            id: invoiceStatus !== "generated" ? surcharge.id : undefined,
            isActive: true,
            fieldName: surcharge.fieldName,
            fieldOperator: surcharge.fieldOperator,
            createdBy: surcharge.createdBy ?? `${username}`,
            updatedBy: `${username}`,
          };
          fuelSurchargeFieldsList.push(field);
        }
      });
    }
  }
  return fuelSurchargeFieldsList;
};
